import envRoutes from './env-routes';

const serverEnv = process.env.VUE_APP_SERVER || 'production';

export default {
  ...envRoutes[serverEnv],
  serverEnv,
};
